import { TAdfoxContextProviderProps } from 'shared/context/AdfoxContext';
import {
  TAdfoxBannerSizeProps,
  PParams as TAdfoxPParams,
  TTgbNativedescGeneralDesign,
} from 'shared/types/microfrontends/adBanner';

/** Баннерные места карточки объекта на десктопе */
export type TOfferCardAdBannerPlace = 'above_header' | 'aside' | 'footer';

export interface IOfferCardAdfoxPlacement {
  place: TOfferCardAdBannerPlace;
  pParams: TAdfoxPParams;
  analyticsPlace: string;
  sizes: TAdfoxBannerSizeProps;
  tgbNativedescGeneralDesign: TTgbNativedescGeneralDesign | null;
  postViewAnalyticsData: TAdfoxContextProviderProps['postViewAnalyticsData'];
  bannerPlace?: TAdfoxContextProviderProps['bannerPlace'];
}

export const OFFER_CARD_DESKTOP_CARD_ADFOX_PLACEMENTS: Record<TOfferCardAdBannerPlace, IOfferCardAdfoxPlacement> = {
  above_header: {
    place: 'above_header',
    pParams: { p1: 'bvknz', p2: 'y' },
    analyticsPlace: 'above_header',
    tgbNativedescGeneralDesign: null,
    sizes: { width: '100%', height: 200 },
    postViewAnalyticsData: {
      place: 'above_header',
      place__DEPRECATED: 'offerCard',
      name__DEPRECATED: 'StretchBanner',
    },
  },
  aside: {
    place: 'aside',
    pParams: { p1: 'dbfka', p2: 'fkhj' },
    analyticsPlace: 'aside',
    tgbNativedescGeneralDesign: 'desktop-card',
    sizes: { width: '100%', height: 433 },
    postViewAnalyticsData: {
      place: 'aside',
      place__DEPRECATED: 'offerCard',
      name__DEPRECATED: 'Brand_banner',
    },
    bannerPlace: 'aside',
  },
  footer: {
    place: 'footer',
    pParams: { p1: 'ddcga', p2: 'fkhj' },
    analyticsPlace: 'footer',
    tgbNativedescGeneralDesign: null,
    sizes: { width: '100%', height: 276 },
    postViewAnalyticsData: {
      place: 'footer',
      place__DEPRECATED: 'offersSerp',
      name__DEPRECATED: 'TgbBottomBanners',
    },
    bannerPlace: 'bottom',
  },
};
